import React from 'react';
import { KOBOO_BLUE } from '../../constants/colors';

const roundSize = '18px';

const spinnerStyle = {
  parent: {
    margin: '100px auto 0',
    width: 'auto',
    textAlign: 'center',
  },
  child: {
    width: roundSize,
    height: roundSize,
    backgroundColor: KOBOO_BLUE,
    margin: '0.5em',
    borderRadius: '100%',
    display: 'inline-block',
  },
};

const Spinner = (props) => {
  const style = spinnerStyle;
  if (props.style) {
    style.parent = { ...spinnerStyle.parent, ...props.style.parent };
    style.child = { ...spinnerStyle.child, ...props.style.child };
  }
  return (
    <div className="spinner" style={style.parent}>
        <div className="bounce1" style={style.child} />
        <div className="bounce2" style={style.child} />
        <div className="bounce3" style={style.child} />
    </div>);
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Layout/Spinner.jsx